import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import { Container, Typography } from '@/components';
import { MenuItems } from '@/components/menu';
import { Route } from '@/constants';

export function UserSidebar() {
  const { t } = useTranslation(['sidebar']);
  const path = useLocation().pathname;

  const navbarItems = useMemo(
    () =>
      [
        {
          menuitems: [
            {
              to: Route.ProfileSettings,
              icon: 'person',
              label: t(`Profile Settings`),
              active: path.startsWith(Route.ProfileSettings),
            },
          ],
        },
        {
          menuitems: [
            {
              to: Route.PlanSettings,
              icon: 'credit-card',
              label: t(`Plans & Billing`),
              active: path.startsWith(Route.PlanSettings),
            },
          ],
        },
        {
          menuitems: [
            {
              to: Route.CompanySettings,
              icon: 'buildings',
              label: t(`Company`),
              active: path.startsWith(Route.CompanySettings),
            },
          ],
        },
       /*  {
          menuitems: [
            {
              to: Route.TeamSettings,
              icon: 'people',
              label: t(`Team`),
              active: path === Route.TeamSettings,
            },
          ],
        }, */
      ] as MenuItems,
    [path, t]
  );

  const activeLabel = useMemo(() => {
    for (const section of navbarItems) {
      const activeItem = section.menuitems.find((item) => item.active);
      if (activeItem) {
        return activeItem.label;
      }
    }
    return t('Profile Settings');
  }, [navbarItems, t]);

  return (
    <Container size="xl">
      <div className="pt-6 pb-2">
        <Typography as="h1" size="heading-2" weight="semibold">
          {activeLabel}
        </Typography>
      </div>

      <div className="w-full">
        <Outlet />
      </div>
    </Container>
  );
}
